module.exports = __webpack_public_path__ + "static/showcase-tile-03-b9ac98b3aa087f2e2e0dd58598761b8c.jpg";